import { useQuery } from '@tanstack/react-query';

import { coreActionsAxiosClient } from '@/lib';
import { Nullable, Timestamp } from '@/types';
import { withLogger } from '@/utils';

import { meetingQuery } from '../data/query-keys';

type DiscussionPoint = {
  name: string | null;
};

type AgendaItem = {
  itemNo: string;
  topic: string;
  discussion_points: DiscussionPoint[] | null;
};

export type Meeting = {
  id: string;
  meeting_name: string;
  status: string;
  category: string;
  agenda: AgendaItem[] | undefined | null;
  created_at: Nullable<Timestamp>;
  updated_at: Nullable<Timestamp>;
  deleted_at: Nullable<Timestamp>;
};

type ApiResponse = {
  data: Meeting[];
  message: string;
};

const getMeetingTypes = withLogger(async (): Promise<ApiResponse> => {
  const { data } = await coreActionsAxiosClient.get<ApiResponse>(`/template`);
  return data;
});

export const useGetMeetingTypes = () => {
  return useQuery<ApiResponse, Error>({
    queryKey: meetingQuery.getMeetingTypes,
    queryFn: () => getMeetingTypes(),
    staleTime: 5000, // 5 seconds
  });
};
